'use strict'

// Runtime copy of @react-native/assets-registry/registry without Flow syntax.

const assets = []

function registerAsset(asset) {
  return assets.push(asset)
}

function getAssetByID(assetId) {
  return assets[assetId - 1]
}

export { registerAsset, getAssetByID }
